import { Injectable } from '@angular/core';
import { APP_CONFIG } from '../../app.config';
import { UtilHelper } from '../../shared/helpers/utils.helper';
import { RequestService } from '../../shared/services/request.service';
import { Table, TableListModel } from './models/table-list.model';

@Injectable()
export class TableService {
  constructor(private requestService: RequestService) {}

  async getTables(storeId: number, placeId?: number): Promise<Array<TableListModel>> {
    let urlRequest: string = APP_CONFIG.WEBSERVICE.TABLES;
    if (storeId) {
      urlRequest += '?establishmentId=' + storeId;
    } else if (placeId) {
      urlRequest += '?placeId=' + placeId;
    }
    const response: any = await this.requestService.getData(urlRequest);
    console.log(response);
    const tableList: Array<TableListModel> = [];
    if (response) {
      //Formato o response para mostrar segmentado por Setor, convertendo para tipo TableListModel
      response.forEach((table: Table) => {
        const sector: string = (table.sector || 'Geral').toUpperCase().trim();
        let sectorList: TableListModel;
        const sectorIndex: number = tableList.findIndex((t: TableListModel) => {
          return t.sector === sector;
        });
        //Verifica se é um setor já existente ou um novo
        if (sectorIndex >= 0) {
          sectorList = tableList[sectorIndex];
        } else {
          sectorList = new TableListModel(sector, []);
        }
        sectorList.list.push({
          id: table.id,
          establishmentId: table.establishmentId,
          placeId: table.placeId,
          sector: table.sector,
          mainIdentification: String(table.mainIdentification).toUpperCase().trim(),
          qrCode: table.qrCode,
        });
        sectorList.list.sort((a, b) => {
          const identificationA: number | string = UtilHelper.getNumericValueIfPossible(
            a.mainIdentification
          );
          const identificationB: number | string = UtilHelper.getNumericValueIfPossible(
            b.mainIdentification
          );
          return identificationA > identificationB ? 1 : -1;
          // return a.mainIdentification > b.mainIdentification ? 1 : -1;
        });
        if (sectorIndex >= 0) {
          tableList[sectorIndex] = sectorList;
        } else {
          tableList.push(sectorList);
        }
      });
    }
    return tableList;
  }

  async addTables(tables: Array<TableListModel>): Promise<any> {
    const tablesToSend: Array<Table> = [];
    tables.forEach((t: TableListModel) => {
      if (t.list && t.list.length > 0) {
        tablesToSend.push.apply(tablesToSend, t.list);
      }
    });
    return await this.requestService.postData(APP_CONFIG.WEBSERVICE.TABLES, tablesToSend);
  }

  async editTable(table: Table): Promise<any> {
    return await this.requestService.putData(APP_CONFIG.WEBSERVICE.TABLES, [table]);
  }

  async deleteTables(tables: Array<Table>): Promise<any> {
    let urlRequest: string = APP_CONFIG.WEBSERVICE.TABLES + '?ids=';
    for (let i: number = 0; i < tables.length; i++) {
      urlRequest += tables[i].id;
      if (i < tables.length - 1) {
        urlRequest += ',';
      }
    }
    return await this.requestService.deleteData(urlRequest);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/tables/table.service.ts